import { createSelector } from 'reselect';
import { DOMAIN_NAME } from './common';

const root = (state) => state[DOMAIN_NAME];

export const clientsSelector = createSelector(root, (s) => s.clients);
export const loadingSelector = createSelector(root, (s) => s.loading);
export const errorSelector = createSelector(root, (s) => s.error);

export const detailSelector = createSelector(root, (s) => s.detail);
export const detailLoadingSelector = createSelector(root, (s) => s.detailLoading);

// Section-specific selectors so unrelated sections do not re-render when one
// section's array changes (each returns a stable reference until that section
// itself is mutated by the reducer).
export const clientWebsitesSelector = createSelector(detailSelector, (d) => (d && d.websites) || []);
export const clientWorkPeriodsSelector = createSelector(detailSelector, (d) => (d && d.workPeriods) || []);
export const clientGitReposSelector = createSelector(detailSelector, (d) => (d && d.gitRepos) || []);
export const clientStacksSelector = createSelector(detailSelector, (d) => (d && d.stacks) || []);
export const clientEmployeesSelector = createSelector(detailSelector, (d) => (d && d.employees) || []);
export const clientTeamsSelector = createSelector(detailSelector, (d) => (d && d.teams) || []);

export const lastCreatedClientIdSelector = createSelector(root, (s) => s.lastCreatedClientId);

export const paginationSelector = createSelector(root, (s) => s.pagination);
export const filtersSelector = createSelector(root, (s) => s.filters);
export const sortSelector = createSelector(root, (s) => s.sort);

export const selectedClientSelector = createSelector(root, (s) => s.selectedClient);
export const isClientDialogOpenSelector = createSelector(root, (s) => s.isClientDialogOpen);
export const isDeleteDialogOpenSelector = createSelector(root, (s) => s.isDeleteDialogOpen);
export const isDetailDialogOpenSelector = createSelector(root, (s) => s.isDetailDialogOpen);

export const teamOptionsSelector = createSelector(root, (s) => s.teamOptions);

export const employeeOptionsSelector = createSelector(root, (s) => s.employeeOptions);
export const employeeOptionsLoadingSelector = createSelector(root, (s) => s.employeeOptionsLoading);
export const teamOptionsLoadingSelector = createSelector(root, (s) => s.teamOptionsLoading);

export const totalPagesSelector = createSelector(paginationSelector, (p) =>
    Math.ceil((p.total || 0) / (p.limit || 10)) || 1
);
